export default abstract class Translation {
  getDictionary() {
    return Object.entries(this).reduce((acc, [key, value]) => ({...acc, [key]: value}), {})
  }
}
